@if (indexContentData) {
  <div class="schoolingContentContainer">
    @if (indexContentData.index.pageType === 1 && resultText) {
      <div class="overlay {{ success[1].failureReason === 'noAnswerGiven' ? '' : success[1].success === false ? 'false' : 'success' }}"
        (click)="clearResultOverlay()"
        >
        <h1>{{resultText}}</h1>
      </div>
    }
    @if (indexContentData.index.pageType === 0) {
      <div class="image-container" style="width: 100%">
        <div class="imageHeader">{{ index.name }}</div>
        @if (!indexContentData.page.content) {
          <img src="{{source}}" (pinch)="onPinch($event)" (pinchend)="onPinchEnd()" #image>
        }
        @if (indexContentData.page.content) {
          <div class="schoolingContentHTML" [innerHTML]="indexContentData.page.content | safeHtml"></div>
        }
      </div>
    }
    @if (indexContentData.index.pageType === 1) {
      <div class="schoolingContentHTML">
        <div class="questionaryHeadline">{{ index.name }}</div>
        @for (questionDetail of questionDetails; track questionDetail) {
          <div class="schoolingContentQuestionContainer" id="{{ questionDetail.question.id }}">

            <div class="schoolingContentQuestionHeader" style="display: flex; align-items: center; gap: 8px;">

              @if (questionary.type) {
                <div class="schoolingContentQuestion">{{ questionDetail.question.name }} ({{ questionDetail.question.points }} {{ 'points' | translate }})</div>
              } @else {
                <div class="schoolingContentQuestion">{{ questionDetail.question.name }}</div>
              }

              @if (questionResultsMap[questionDetail.question.id] === true) {
                <mat-icon class="colorGreen">check</mat-icon>
              }

              @if (questionResultsMap[questionDetail.question.id] === false) {
                <mat-icon class="colorRed">clear</mat-icon>
              }

            </div>

            <div class="subHeader">
              @if (questionDetail.question.type === 1) {
                <span>{{ 'multipleChoice' | translate}}</span>
              }
            </div>
            @for (answer of questionDetail.answers; track answer) {
              <div class="schoolingContentAnswerContainer"
                   (click)="toggleAnswer(questionDetail.question.id, answer.id, questionDetail.question.type)">
                <div class="schoolingContentAnswer">
                  <input id="{{ 'answer_' + answer.id }}" class="answerInputField {{ 'answerOfQuestion_' + questionDetail.question.id }}" value="{{ answer.id }}" type="checkbox"
                         (click)="$event.stopPropagation(); questionDetail.question.type === 0 ? setStandardQuestionCheckboxes(questionDetail.question.id, answer.id) : null">
                  <span class="answerText">{{ answer.name }}</span>
                </div>
              </div>
            }
          </div>
        }
      </div>
    }
    @if (indexContentData.index.pageType === 2) {
      <div>
        <div class="schoolingContentVideo">
          <video class="video" controls preload="auto"
            poster="{{ indexContentData.serverAddress }}/style/images/LogoWhiteBack.png">
            <source src="{{source}}" type="video/mp4">
          </video>
        </div>
      </div>
    }
  </div>
}
